<div #expandWrapper class="expand-wrapper" [class.collapsed]="!expanded">
  <ng-content></ng-content>
</div>